/* ••[1]••••••••••••••••••••••••• eventCarousel.ts •••••••••••••••••••••••••••••• */

import { Component, CustomElement } from "../../core/CustomElement";
import Carousel from "../carousel/carousel";
import {
  EventCarouselItem,
  validatedEventCarouselItems,
} from "../../core/types/EventCarousel";
import { validateJsonStringified } from "../../core/utilities";

@Component("ccc-event-carousel", {
  template: require("./eventCarousel.html").default,
  style: require("./eventCarousel.scss").default,
  viewModel: require("./eventCarouselVm"),
  observedAttributes: ["items"],
})
export default class CCCEventCarousel extends CustomElement {
  // eslint-disable-next-line
  private carousel: any;

  constructor() {
    super();
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: unknown,
    newValue: unknown
  ): void {
    switch (attr) {
      case "items": {
        const newValueObj: Array<EventCarouselItem> =
          validateJsonStringified(newValue as string) ?? [];

        this.viewModel.items(validatedEventCarouselItems(newValueObj));
        this.initializeCarousel();
        break;
      }
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public set items(value: Array<EventCarouselItem>) {
    if (typeof value === "object") {
      this.viewModel.items(validatedEventCarouselItems(value));
      this.initializeCarousel();
    }
  }

  private initializeCarousel(): void {
    const $eventCarouselItemsContainer: HTMLDivElement =
      this.shadowDom.querySelector(".event-carousel-items-container");

    if (this.carousel) {
      this.carousel.destroy();
    }

    this.carousel = new Carousel($eventCarouselItemsContainer);
  }
}

// https://www.figma.com/file/8dAQp4d1MS6YQt44jWZSYu/Vanilla?node-id=1337%3A136517
